module.exports = __webpack_public_path__ + "static/media/zolo.194bbdb0.svg";